

let healthPanel = {};
let currentEle;
let currentElePanel;
let currentEleImage;

healthPanel.init = () => {
  healthPanel.setupPanel('js-panel-item', 'hbPanel', true);
  healthPanel.setupPanel('js-panel-description', 'forhbPanel', false);
  healthPanel.setupPanel('js-panel-image', 'forImagehbPanel', false);
}

healthPanel.setupPanel = (e, name, bol) => {
  let ele = document.getElementsByClassName(e);

  for(let i = 0; i < ele.length; i++) {
    if(!ele[i]) return;

    ele[i].id = name + i;

    if(bol) {
      ele[i].addEventListener('click', (e) => {
        healthPanel.iconAction(e);
      });
    }
  }
}

healthPanel.iconAction = (e) => {
  if (!e) return;
  currentEle = e.target.id;
  currentElePanel = "for" + e.target.id;
  currentEleImage = "forImage" + e.target.id;

  if (!e.target.classList.contains('is-active')) {
    e.target.classList.add('is-active');
  } else {
    if(!currentEle == e.target.id) {
      e.target.classList.remove('is-active');
    }
  }

  if(!document.getElementById(currentElePanel).classList.contains('is-active')) {
    document.getElementById(currentElePanel).classList.add('is-active');
  } else {
    if(!currentElePanel == "for" + e.target.id) {
      document.getElementById(currentElePanel).classList.remove('is-active');
    }
  }

  if(!document.getElementById(currentEleImage).classList.contains('is-active')) {
    document.getElementById(currentEleImage).classList.add('is-active');
  } else {
    if(!currentEleImage == "forImage" + e.target.id) {
      document.getElementById(currentEleImage).classList.remove('is-active');
    }
  }

  healthPanel.checker(e.target.className, currentEle);
  healthPanel.checker(document.getElementById(currentElePanel).className, currentElePanel);
  healthPanel.checker(document.getElementById(currentEleImage).className, currentEleImage);
}


//check btn which is active
healthPanel.checker = (e, comparer) => {
  let eleBtn = document.getElementsByClassName(e);
  if (!eleBtn) return;

  for (let i = 0; i < eleBtn.length; i++) {
    if (eleBtn[i].id !== comparer) {
      eleBtn[i].classList.remove('is-active');
    }

    if (i > 10000) break;
  }
}

document.addEventListener('DOMContentLoaded', function () {
  healthPanel.init();
});



// WEBPACK FOOTER //
// ./scripts/components/health_panel.js